import { SessionStorageService } from './session/session-storage/session-storage.service';

export abstract class SessionableDataModel {

  constructor(protected sessionStorageService: SessionStorageService) { }

  protected abstract get key(): string;

  // The populate() function will always edit the existing injected instance of whatever
  // model context we're in (this) from the saved top level instance (i.e. mapping something
  // like data.loanOfficer.loanOfficerId to data requires us to know that mapping ahead of time).
  public abstract populate(model?: any): any;

  protected abstract map(model: any): any;

  protected save(setter: (model: any) => void): void {
    const data = this.getSessionData();
    const mappedData = data ? this.map(data) : null;
    setter(mappedData);
    this.populate(mappedData);
    this.setSessionData(data);
  }

  public setSessionData(data: any) {
    const jsonToStore = data;
    this.sessionStorageService.setItem(this.key, jsonToStore);
  }

  public getSessionData(): any {
    const data = this.sessionStorageService.getItem(this.key);
    const model = typeof data === 'object'
      ? data
      : JSON.parse(data);

    let mappedData = model ? this.map(model) : null;
    this.populate(mappedData);
    return model;
  }

  public clear(): void {
    this.sessionStorageService.removeItem(this.key);
    const newData = this.populate();
    this.sessionStorageService.setItem(this.key, newData);
  }
}
